import { yup } from '@guiker/yup-util'

export const searchListingSchema = yup.object({
  type: yup.string().oneOf(['FractionalOwnershipListing', 'PropertySaleListing']),
})

export type SearchListingSchema = yup.InferType<typeof searchListingSchema>
